import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-55d3c380"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pbl"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottombg"
}, null, -1));
const _hoisted_3 = {
  class: "wrap"
};
const _hoisted_4 = {
  class: "wrapinner",
  id: "wrapinner"
};
const _hoisted_5 = {
  class: "wrapbox"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "videoBoxli"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "bottom"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "http://data.museum.chaoxing.com/micro-upload/ycsbwg/static/img/icon-3d.png",
  alt: ""
}, null, -1));
const _hoisted_11 = {
  class: "videoName"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_pblWindow = _resolveComponent("pblWindow");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["topbg", 'topbg' + $data.singleform.deptId])
  }, null, 2), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "videoBox",
      onClick: $event => $options.clickItem(index)
    }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, _toDisplayString(item.name), 1)])])])], 8, _hoisted_6);
  }), 256))])])]), $data.showWindow ? (_openBlock(), _createBlock(_component_pblWindow, {
    key: 0,
    modelData: $data.modelData,
    config: $data.config,
    detailUrl: $data.detailUrl,
    windowTop: $data.windowTop
  }, null, 8, ["modelData", "config", "detailUrl", "windowTop"])) : _createCommentVNode("", true)]);
}